import { useState } from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const PLACEHOLDER = "/images/reservation_fallback.png";

const CardBox = ({ item, sx = {}, onCategoryClick }) => {
  const [imgSrc, setImgSrc] = useState(item.image);
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    if (!hasError) {
      setHasError(true);
      setImgSrc(PLACEHOLDER);
    }
  };

  return (
    <Box
      onClick={() => onCategoryClick(item.slug, item.id)}
      sx={{
        position: "relative",
        borderRadius: "20px",
        overflow: "hidden",
        cursor: "pointer",
        transition: "all 0.3s ease",
        "&:hover": {
          transform: "scale(1.03)",
          boxShadow: "0 8px 24px rgba(119, 18, 55, 0.15)",
        },
        "&:active": { transform: "scale(0.98)" },
        ...sx,
      }}
    >
      <Box
        component="img"
        src={imgSrc}
        alt={item.title}
        onError={handleError}
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          ...(hasError && {
            objectFit: "cover",
            backgroundColor: "#f5f5f5",
          }),
        }}
      />
      {item.count > 0 && (
        <Box
          sx={{
            position: "absolute",
            top: 12,
            right: 12,
            backgroundColor: "#fff",
            px: 1.5,
            py: 0.5,
            borderRadius: "999px",
            fontSize: 12,
            fontWeight: 500,
            color: "#771237",
            pointerEvents: "none",
          }}
        >
          {item.count} Cake
        </Box>
      )}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          p: 2,
          background: "linear-gradient(to top, rgba(0,0,0,0.6), transparent)",
          pointerEvents: "none",
        }}
      >
        <Typography
          sx={{
            color: "#fff",
            fontSize: 16,
            fontFamily: "'Unbounded', sans-serif",
            fontWeight: 600,
            textAlign: "center",
          }}
        >
          {item.title}
        </Typography>
      </Box>
    </Box>
  );
};

const CategoryGrid = ({ allCategories = [] }) => {
  const navigate = useNavigate();

  const items = allCategories.slice(0, 5).map((item) => ({
    id: item.id,
    slug: item?.slug || "",
    image: item?.categoryImages?.[0]?.Image || PLACEHOLDER,
    title: item?.categoryLocales?.[0]?.name || "Category",
    count: item?.productCount ?? 0,
  }));

  const handleCategoryClick = (slug, id) => {
    if (slug && id) {
      navigate(`/productlist/${slug}/${id}`);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 1200,
        mx: "auto",
        px: 2,
        display: "grid",
        gap: 2,
        gridTemplateAreas: {
          xs: `
            "a b"
            "c d"
            "e e"
          `,
          md: `
            "a b b"
            "c d e"
          `,
        },
        gridTemplateColumns: {
          xs: "1fr 1fr",
          md: "1fr 1fr 1fr",
        },
      }}
    >
      {items[0] && (
        <CardBox item={items[0]} sx={{ gridArea: "a", height: { xs: 180, md: 260 } }} onCategoryClick={handleCategoryClick} />
      )}
      {items[1] && (
        <CardBox item={items[1]} sx={{ gridArea: "b", height: { xs: 180, md: 260 } }} onCategoryClick={handleCategoryClick} />
      )}
      {items[2] && (
        <CardBox item={items[2]} sx={{ gridArea: "c", height: { xs: 180, md: 260 } }} onCategoryClick={handleCategoryClick} />
      )}
      {items[3] && (
        <CardBox item={items[3]} sx={{ gridArea: "d", height: { xs: 180, md: 260 } }} onCategoryClick={handleCategoryClick} />
      )}
      {items[4] && (
        <CardBox item={items[4]} sx={{ gridArea: "e", height: { xs: 180, md: 260 } }} onCategoryClick={handleCategoryClick} />
      )}
    </Box>
  );
};

export default CategoryGrid;
